import {
  createFetchPaginatedActionForNamespace,
  createFetchSelectors,
  createFetchReducersWithPagination,
  createReducer,
  createFetchActionForNamespace,
  createFetchReducers,
  noDataForAction,
  createPostActionForNamespace
} from 'utils/reducers';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';
import {selectPagination, PAGINATION} from 'ducks/pagination';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {selectFilters, FILTERS} from 'ducks/filters';
import {transformSortForStoreToSortForUrl} from 'utils/sort';
import {selectSort, SORTING} from 'ducks/sorting';

const createFetchPaginatedAction = createFetchPaginatedActionForNamespace(
  'payments'
);
const createPostAction = createPostActionForNamespace('payments');

export const fetchPayments = createFetchPaginatedAction({
  name: 'FETCH_PAYMENTS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'payments',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.PAYMENTS_LIST)
      ),
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.PAYMENTS_LIST)
      ),
    state =>
      transformSortForStoreToSortForUrl(
        selectSort(state, SORTING.PAYMENTS_LIST)
      )
  ],
  paginationNamespace: PAGINATION.PAYMENTS_LIST
});
const paymentsSelector = createFetchSelectors(fetchPayments);
export const selectPayments = paymentsSelector.data;
export const selectPaymentsLoading = paymentsSelector.isLoading;

const createFetchAction = createFetchActionForNamespace('payments');

export const fetchScheduleTypesFilters = createFetchAction({
  name: 'FETCH_SCHEDULE_TYPES_FILTERS',
  initialAction: noDataForAction,
  stateKey: 'scheduleTypesFilters',
  defaultStateValue: []
});

const scheduleTypesFiltersSelector = createFetchSelectors(
  fetchScheduleTypesFilters
);

export const fetchOneOffChargeReasonFilters = createFetchAction({
  name: 'FETCH_ONE_OFF_CHARGE_REASON_FILTERS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'oneOffChargeReasonFilters',
  defaultStateValue: []
});

const oneOffChargeReasonFiltersSelector = createFetchSelectors(
  fetchOneOffChargeReasonFilters
);

export const fetchXeroAccountsFilters = createFetchAction({
  name: 'FETCH_XERO_ACCOUNTS_FILTERS',
  initialAction: ({locationRef}) => ({
    payload: {locationRef}
  }),
  stateKey: 'xeroAccountsFilters',
  defaultStateValue: []
});

const xeroAccountsFiltersSelector = createFetchSelectors(
  fetchXeroAccountsFilters
);

export const selectScheduleTypesFilters = scheduleTypesFiltersSelector.data;
export const selectXeroAccountsFilters = xeroAccountsFiltersSelector.data;
export const selectOneOffChargeReasonsFilters =
  oneOffChargeReasonFiltersSelector.data;
export const selectScheduleTypesFiltersLoading =
  scheduleTypesFiltersSelector.isLoading;

export const voidInvoices = createPostAction({
  name: 'VOID_INVOICES',
  initialAction: ({invoices}, extraActions = []) => ({
    payload: {
      invoices,
      extraActions
    }
  })
});

export const fetchCreditNotes = createFetchPaginatedAction({
  name: 'FETCH_CREDIT_NOTES',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'creditNotesList',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.CREDIT_NOTES_LIST)
      ),
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.CREDIT_NOTES_LIST)
      ),
    state =>
      transformSortForStoreToSortForUrl(
        selectSort(state, SORTING.CREDIT_NOTES_LIST)
      )
  ],
  paginationNamespace: PAGINATION.CREDIT_NOTES_LIST
});
const creditNotesSelector = createFetchSelectors(fetchCreditNotes);
export const selectCreditNotes = creditNotesSelector.data;
export const selectCreditNotesLoading = creditNotesSelector.isLoading;

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducersWithPagination(fetchPayments),
  ...createFetchReducers(fetchScheduleTypesFilters),
  ...createFetchReducersWithPagination(fetchCreditNotes),
  ...createFetchReducers(fetchXeroAccountsFilters),
  ...createFetchReducers(fetchOneOffChargeReasonFilters)
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;
export {default as paymentsSaga} from './saga';
